module.exports = __webpack_public_path__ + "static/media/5.d36e7a13.gif";